module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Black.cb44c93a.ttf";